// src/frontend/pages/FiveClassesViewer.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const TITLE_BLUE = "#175cd3";
const SIDEBAR_BG = "#f7f9fb";
const SIDEBAR_BORDER = "#e6ebf1";

const BASE_PATH = "/course/clases";

/**
 * ✅ AQUÍ SE PONEN LOS VIDEOS:
 * En classesData[].youtubeId
 *
 * Ejemplo:
 *  URL: https://www.youtube.com/watch?v=yrItKXnWJnk
 *  youtubeId = "yrItKXnWJnk"
 */

// 👉 Imagen por defecto para overlay (cámbiala por la tuya)
const DEFAULT_OVERLAY_IMAGE =
  "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/ChatGPT%20Image%2018%20feb%202026%2C%2006_42_16.png";

// ✅ Datos de clases (edita youtubeId en la clase 3)
const classesData = [
  {
    id: 1,
    title: "Clase 1-Introducción",
    youtubeId: "XBktHWP8TLA",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Historia del dinero (lectura complementaria)", to: "/course/historia-del-dinero" },
    ],
  },
  {
    id: 2,
    title: "Clase 2-Fundamentos del Bitcoin: Dinero digital, escasez y descentralización",
    youtubeId: "hcGkZGrjWpA",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Blockchain en la Industria", to: "/course/blockchain-en-la-industria" },
      { label: "Blockchain Esencial", to: "/course/blockchain-fundamentos-esenciales/1" },
    ],
  },
  {
    id: 3,
    title: "Clase 3-Usos reales de la tecnología Blockchain",
    youtubeId: "VVQB2CJfdfs", // ✅ CAMBIA ESTO (no pongas VIDEO_ID_3)
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Explorando Hash y SHA-256", to: "/course/blockchain-en-la-industria" },
      { label: "Blockchain Esencial", to: "/course/blockchain-fundamentos-esenciales/1" },
      { label: "Curso Dominando el Blockchain: Día 1-7", to: "/course/CDB" },
    ],
  },
  {
    id: 4,
    title: "Clase 3.1-El BITCOIN",
    youtubeId: "yrItKXnWJnk",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Bitcoin un antes y un después en la historia del dinero", to: "/course/bitcoin-historia" },
      { label: "Minería del Blockchain", to: "/course/mineria-blockchain" },
      { label: "Criptografía en Blockchain", to: "/course/criptografia-blockchain" },
      { label: "Bitcoin: De Cero a Avanzado", to: "/course/bitcoin-master/1" },
      { label: "Curso Dominando el Blockchain: Día 7-14", to: "/course/CDB" },
    ],
  },
  {
    id: 5,
    title: "Clase 4-¿Qué son las  wallets?",
    youtubeId: "7ao-x20_6B8",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Criptografía en Blockchain", to: "/course/criptografia-blockchain" },
      { label: "Explorando Hash y SHA-256", to: "/course/explorando-hash-sha256" },

      { label: "Criptografía Asimétrica y las Claves Públicas y Privadas", to: "/course/criptografia-asimetrica" },
      { label: "Introducción a Wallets con Blockchain", to: "/course/introduccion-wallets-blockchain" },
      { label: "Curso Dominando el Blockchain: Día 7-14", to: "/course/CDB" },
    ],
  },
  

  {
    id: 6,
    title: "Clase 4.1-Explorando todo sobre METAMASK",
    youtubeId: "oNg8UApkz1g",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Criptografía en Blockchain", to: "/course/criptografia-blockchain" },
      { label: "Explorando Hash y SHA-256", to: "/course/explorando-hash-sha256" },

      { label: "Criptografía Asimétrica y las Claves Públicas y Privadas", to: "/course/criptografia-asimetrica" },
      { label: "Introducción a Wallets con Blockchain", to: "/course/introduccion-wallets-blockchain" },
      { label: "Curso Dominando el Blockchain: Día 7-14", to: "/course/CDB" },
    ],
  },
  {
    id: 7,
    title: "Clase 4.2-Explorando Metamask y las transacciones",
    youtubeId: "w5rXyJCxWe8",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Criptografía en Blockchain", to: "/course/criptografia-blockchain" },
      { label: "Explorando Hash y SHA-256", to: "/course/explorando-hash-sha256" },

      { label: "Criptografía Asimétrica y las Claves Públicas y Privadas", to: "/course/criptografia-asimetrica" },
      { label: "Introducción a Wallets con Blockchain", to: "/course/introduccion-wallets-blockchain" },
      { label: "Curso Dominando el Blockchain: Día 7-14", to: "/course/CDB" },
    ],
  },

    {
    id: 8,
    title: "Clase 4.3-Trezor Safe 3",
    youtubeId: "Guk3n5FpP-w",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Criptografía en Blockchain", to: "/course/criptografia-blockchain" },
      { label: "Explorando Hash y SHA-256", to: "/course/explorando-hash-sha256" },

      { label: "Criptografía Asimétrica y las Claves Públicas y Privadas", to: "/course/criptografia-asimetrica" },
      { label: "Introducción a Wallets con Blockchain", to: "/course/introduccion-wallets-blockchain" },
      { label: "Curso Dominando el Blockchain: Día 7-14", to: "/course/CDB" },
    ],
  },
      {
    id: 9,
    title: "Clase 4.4-Trezor Safe 5 y METAMASK",
    youtubeId: "q4B6HYxrst8",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Criptografía en Blockchain", to: "/course/criptografia-blockchain" },
      { label: "Explorando Hash y SHA-256", to: "/course/explorando-hash-sha256" },

      { label: "Criptografía Asimétrica y las Claves Públicas y Privadas", to: "/course/criptografia-asimetrica" },
      { label: "Introducción a Wallets con Blockchain", to: "/course/introduccion-wallets-blockchain" },
      { label: "Curso Dominando el Blockchain: Día 7-14", to: "/course/CDB" },
    ],
  },
    {
    id: 10,
    title: "Clase 4.4-Trezor Safe 5 y METAMASK",
    youtubeId: "q4B6HYxrst8",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Criptografía en Blockchain", to: "/course/criptografia-blockchain" },
      { label: "Explorando Hash y SHA-256", to: "/course/explorando-hash-sha256" },

      { label: "Criptografía Asimétrica y las Claves Públicas y Privadas", to: "/course/criptografia-asimetrica" },
      { label: "Introducción a Wallets con Blockchain", to: "/course/introduccion-wallets-blockchain" },
      { label: "Curso Dominando el Blockchain: Día 7-14", to: "/course/CDB" },
    ],
  },

   {
    id: 11,
    title: "Clase 5-Criptografía y claves en Blockchain",
    youtubeId: "9M3Vi_POlUk",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Criptografía en Blockchain", to: "/course/criptografia-blockchain" },
      { label: "Explorando Hash y SHA-256", to: "/course/explorando-hash-sha256" },
      { label: "Criptografía Asimétrica y las Claves Públicas y Privadas", to: "/course/criptografia-asimetrica" },
    ],
  },
  {
    id: 12,
    title: "Clase 5.1-¿Qué son las criptomonedas?",
    youtubeId: "a9tLx_opK_g",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Introducción a Wallets con Blockchain", to: "/course/introduccion-wallets-blockchain" },
      { label: "Criptografía Asimétrica y las Claves Públicas y Privadas", to: "/course/criptografia-asimetrica" },
      { label: "Curso Dominando el Blockchain: Día 7-14", to: "/course/CDB" },
    ],
  },
  {
    id: 13,
    title: "Clase 6-¿Qué son los Token?",
    youtubeId: "KIglNoUauKE",
    overlayImage: DEFAULT_OVERLAY_IMAGE,
    materials: [
      { label: "Blockchain Esencial", to: "/course/blockchain-fundamentos-esenciales/1" },
      { label: "Bitcoin: De Cero a Avanzado", to: "/course/bitcoin-master/1" },
    ],
  },
  {
  id: 14,
  title: "Clase 7-El tránsito en las redes Blockchain y las transacciones",
  youtubeId: "lPl8um7e9LE",
  overlayImage: DEFAULT_OVERLAY_IMAGE,
  materials: [
    { label: "Cómo funcionan las transacciones en Blockchain", to: "/course/transacciones-blockchain" },
    { label: "Explorando Hash y SHA-256", to: "/course/explorando-hash-sha256" },
    { label: "Criptografía Asimétrica y las Claves Públicas y Privadas", to: "/course/criptografia-asimetrica" },
    { label: "Introducción a Wallets con Blockchain", to: "/course/introduccion-wallets-blockchain" },
    { label: "Curso Dominando el Blockchain: Día 14-21", to: "/course/CDB" },
  ],
},
 {
  id: 15,
  title: "Clase 8-Flujo de las transacciones en Blockchain",
  youtubeId: "xMz3UHxP-Bk",
  overlayImage: DEFAULT_OVERLAY_IMAGE,
  materials: [
    { label: "Cómo funcionan las transacciones en Blockchain", to: "/course/transacciones-blockchain" },
    { label: "Explorando Hash y SHA-256", to: "/course/explorando-hash-sha256" },
    { label: "Criptografía Asimétrica y las Claves Públicas y Privadas", to: "/course/criptografia-asimetrica" },
    { label: "Introducción a Wallets con Blockchain", to: "/course/introduccion-wallets-blockchain" },
    { label: "Curso Dominando el Blockchain: Día 14-21", to: "/course/CDB" },
  ],
},
  {
  id: 16,
  title: "Clase 9-Smart Contracts",
  youtubeId: "quPLWidWzF4",
  overlayImage: DEFAULT_OVERLAY_IMAGE,
  materials: [
    { label: "Introducción a los Smart Contracts", to: "/course/smart-contracts-introduccion" },
    { label: "Blockchain Esencial", to: "/course/blockchain-fundamentos-esenciales/1" },
    { label: "Criptografía en Blockchain", to: "/course/criptografia-blockchain" },
    { label: "Curso Dominando el Blockchain: Día 21-28", to: "/course/CDB" },
  ],
},
{
  id: 17,
  title: "Clase 10-Cómo la Blockchain ha transformado el mundo, otras Blockchain y DEFI",
  youtubeId: "C-_F-Bq8n90",
  overlayImage: DEFAULT_OVERLAY_IMAGE,
  materials: [
    { label: "Blockchain en la Industria", to: "/course/blockchain-en-la-industria" },
    { label: "Blockchain Esencial", to: "/course/blockchain-fundamentos-esenciales/1" },
    { label: "Aplicaciones reales de Blockchain", to: "/course/aplicaciones-blockchain" },
    { label: "Curso Dominando el Blockchain: Día 28-35", to: "/course/CDB" },
  ],
},
  {
  id: 18,
  title: "Clase 11-Práctica: Crear tu primer NFT",
  youtubeId: "xMz3UHxP-Bk",
  overlayImage: DEFAULT_OVERLAY_IMAGE,
  materials: [
    { label: "Introducción a los NFTs", to: "/course/introduccion-nft" },
    { label: "Cómo funcionan los NFTs en Blockchain", to: "/course/nft-blockchain" },
    { label: "Guía para crear tu primer NFT", to: "/course/crear-primer-nft" },
    { label: "Curso Dominando el Blockchain: Día 35-42", to: "/course/CDB" },
  ],
},
  
 
];

// ✅ embed “limpio”
const getYouTubeEmbedUrl = (youtubeId, autoplay = false) => {
  if (!youtubeId || youtubeId === "PON_AQUI_EL_ID_REAL") return "";
  const params = new URLSearchParams({
    rel: "0",
    modestbranding: "1",
    controls: "0",
    fs: "1",
    iv_load_policy: "3",
    playsinline: "1",
    autoplay: autoplay ? "1" : "0",
  }).toString();

  return `https://www.youtube-nocookie.com/embed/${youtubeId}?${params}`;
};

export default function FiveClassesViewer() {
  const { classId } = useParams();
  const navigate = useNavigate();

  const [selected, setSelected] = useState(() => {
    return classesData.find((c) => c.id === Number(classId)) || classesData[0];
  });

  const [activeTab, setActiveTab] = useState("video"); // "video" | "study"
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const found = classesData.find((c) => c.id === Number(classId));
    if (found) {
      setSelected(found);
      setActiveTab("video");
      setIsPlaying(false);
    } else if (classId == null) {
      // si entras sin id, manda a la primera
      navigate(`${BASE_PATH}/${classesData[0].id}`, { replace: true });
    }
  }, [classId, navigate]);

  useEffect(() => {
    if (activeTab !== "video") setIsPlaying(false);
  }, [activeTab]);

  const handleSelect = (cls) => navigate(`${BASE_PATH}/${cls.id}`);

  const handleMaterialClick = (to) => {
    if (/^https?:\/\//i.test(to)) window.open(to, "_blank", "noopener,noreferrer");
    else navigate(to);
  };

  const youtubeSrc = selected?.youtubeId
    ? getYouTubeEmbedUrl(selected.youtubeId, isPlaying)
    : "";

  const handlePlayClick = () => setIsPlaying(true);

  const overlayImage =
    selected?.overlayImage && selected.overlayImage.trim() !== ""
      ? selected.overlayImage
      : DEFAULT_OVERLAY_IMAGE;

  return (
    <div className="vv-serif-root vv-wrap">
      <style>{`
        .vv-serif-root, .vv-serif-root * {
          font-family: Georgia, "Times New Roman", Times, serif;
          letter-spacing: .01em;
        }

        /* ✅ Layout: full height */
        .vv-wrap {
          display: flex;
          min-height: 100dvh;
          background: #fff;
          overflow: hidden;
        }

        /* ✅ Sidebar: full height (sticky) */
        .vv-sidebar {
          width: 280px;
          background: ${SIDEBAR_BG};
          border-right: 1px solid ${SIDEBAR_BORDER};
          display: flex;
          flex-direction: column;

          position: sticky;
          top: 0;
          height: 100dvh;
        }

        .vv-title {
          background: ${TITLE_BLUE};
          color: #fff;
          font-weight: 800;
          font-size: 15px;
          padding: 14px 12px;
          margin: 0 0 8px 0;
          text-align: left;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
        }

        .vv-titleText { flex: 1; }

        .vv-toggleBtn {
          all: unset;
          cursor: pointer;
          font-size: 14px;
          line-height: 1;
          padding: 4px 6px;
          border-radius: 6px;
          border: 1px solid rgba(255,255,255,0.6);
        }
        .vv-toggleBtn:hover { background: rgba(15,23,42,0.25); }

        .vv-subtitle {
          color: #102a43;
          font-weight: 700;
          font-size: 13px;
          padding: 0 12px 8px 12px;
        }

        .vv-sidebarScroll {
          flex: 1;
          overflow-y: auto;
        }

        .vv-items {
          list-style: none;
          margin: 0;
          padding: 0 6px 12px 6px;
        }

        .vv-itemBtn {
          all: unset;
          display: grid;
          grid-template-columns: 12px 1fr auto;
          align-items: center;
          gap: 10px;
          width: 100%;
          padding: 8px 10px 8px 6px;
          margin: 2px 4px;
          color: #243b53;
          cursor: pointer;
          text-align: left;
        }
        .vv-itemBtn:hover { background: #ffffff; }

        .vv-itemLabel {
          font-size: 13px;
          line-height: 1.25;
          white-space: normal;
          overflow: visible;
          text-overflow: unset;
        }

        .vv-itemActive .vv-itemLabel {
          color: ${TITLE_BLUE};
          font-weight: 800;
        }

        .vv-circle {
          width: 10px;
          height: 10px;
          border-radius: 999px;
          border: 2px solid #9ca3af;
        }
        .vv-itemActive .vv-circle {
          border-color: ${TITLE_BLUE};
          background: ${TITLE_BLUE};
        }

        .vv-sidebarCollapsed .vv-sidebarScroll { display: none; }

        /* ✅ Viewer: full height, scroll aquí */
        .vv-viewer {
          flex: 1;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          padding: 16px clamp(12px, 2vw, 24px);
          overflow-y: auto;
          min-height: 100dvh;
        }

        .vv-frameWrap {
          width: 95%;
          max-width: 960px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .vv-classTitle {
          font-size: 20px;
          font-weight: 700;
          color: #0f172a;
          margin: 0 0 4px 0;
        }

        .vv-tabs {
          display: flex;
          gap: 4px;
          border-bottom: 1px solid #1f2937;
          margin-bottom: 8px;
        }

        .vv-tabBtn {
          all: unset;
          cursor: pointer;
          padding: 8px 14px;
          font-size: 13px;
          font-weight: 600;
          border-radius: 8px 8px 0 0;
          color: #9ca3af;
        }

        .vv-tabBtnActive {
          background: #111827;
          color: #f9fafb;
        }

        .vv-videoShell { width: 100%; }

        .vv-videoInner {
          position: relative;
          width: 100%;
          height: 520px;
          overflow: hidden;
          border-radius: 12px;
          box-shadow: 0 10px 25px rgba(15,23,42,0.18);
          background: #000;
        }

        .vv-iframe {
          width: 100%;
          height: 100%;
          border: 0;
          display: block;
        }

        .vv-videoOverlayBtn {
          all: unset;
          position: absolute;
          inset: 0;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .vv-videoOverlayImg {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          pointer-events: none;
        }

        .vv-videoOverlayGradient {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to top,
            rgba(15,23,42,0.75),
            rgba(15,23,42,0.25)
          );
          pointer-events: none;
        }

        .vv-videoOverlayContent {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          text-align: center;
          padding: 16px;
        }

        .vv-overlayPlayIcon {
          width: 56px;
          height: 56px;
          border-radius: 999px;
          border: 2px solid rgba(249,250,251,0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 26px;
          color: #f9fafb;
          box-shadow: 0 0 0 4px rgba(15,23,42,0.3);
          background: rgba(15,23,42,0.65);
          transition: transform .12s ease;
        }

        .vv-overlayPlayText {
          font-size: 16px;
          font-weight: 700;
          color: #e5e7eb;
          text-shadow: 0 1px 3px rgba(15,23,42,0.9);
        }

        .vv-overlaySubtitle {
          font-size: 13px;
          color: #e5e7eb;
          max-width: 360px;
        }

        .vv-videoOverlayBtn:hover .vv-overlayPlayIcon { transform: scale(1.03); }

        .vv-clickShield {
          position: absolute;
          inset: 0;
          pointer-events: auto;
          background: transparent;
        }

        .vv-materials {
          border: 1px solid ${SIDEBAR_BORDER};
          border-radius: 10px;
          padding: 12px 14px;
          background: #f9fafb;
        }

        .vv-materialsTitle {
          margin: 0 0 8px 0;
          font-size: 14px;
          font-weight: 700;
          color: #0f172a;
        }

        .vv-materialsList {
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .vv-materialItemBtn {
          all: unset;
          cursor: pointer;
          font-size: 13px;
          color: ${TITLE_BLUE};
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 6px;
          border-radius: 6px;
        }

        .vv-materialItemBtn:hover { background: #e0edff; }

        .vv-materialBullet {
          width: 4px;
          height: 4px;
          border-radius: 999px;
          background: ${TITLE_BLUE};
        }

        @media (max-width: 900px) {
          .vv-sidebar { width: 240px; }
          .vv-videoInner { height: 420px; }
        }

        @media (max-width: 720px) {
          .vv-wrap {
            flex-direction: column;
            min-height: auto;
            overflow: visible;
          }

          .vv-sidebar {
            width: 100%;
            height: auto;
            position: relative;
            top: auto;
            border-right: none;
            border-bottom: 1px solid ${SIDEBAR_BORDER};
          }

          .vv-viewer {
            overflow-y: visible;
            min-height: auto;
          }

          .vv-videoInner { height: 360px; }
        }
      `}</style>

      {/* Sidebar */}
      <aside
        className={`vv-sidebar ${sidebarCollapsed ? "vv-sidebarCollapsed" : ""}`}
        aria-label="Navegación de Clases"
      >
        <h1 className="vv-title">
          <span className="vv-titleText">Dominando Blockchain</span>
          <button
            type="button"
            className="vv-toggleBtn"
            onClick={() => setSidebarCollapsed((v) => !v)}
            aria-label={sidebarCollapsed ? "Mostrar lista de clases" : "Ocultar lista de clases"}
          >
            {sidebarCollapsed ? "▾" : "▴"}
          </button>
        </h1>

        <div className="vv-sidebarScroll">
          <div className="vv-subtitle">CLASES</div>
          <ul className="vv-items">
            {classesData.map((cls) => {
              const active = selected?.id === cls.id;
              return (
                <li key={cls.id}>
                  <button
                    className={`vv-itemBtn ${active ? "vv-itemActive" : ""}`}
                    onClick={() => handleSelect(cls)}
                    aria-current={active ? "page" : undefined}
                    type="button"
                  >
                    <span aria-hidden="true" />
                    <span className="vv-itemLabel">{cls.title}</span>
                    <span className="vv-circle" aria-hidden="true" />
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </aside>

      {/* Viewer */}
      <main className="vv-viewer">
        <div className="vv-frameWrap">
          <h1 className="vv-classTitle">{selected?.title}</h1>

          <nav className="vv-tabs" aria-label="Tipo de recurso">
            <button
              type="button"
              className={`vv-tabBtn ${activeTab === "video" ? "vv-tabBtnActive" : ""}`}
              onClick={() => setActiveTab("video")}
              aria-selected={activeTab === "video"}
            >
              Video
            </button>
            <button
              type="button"
              className={`vv-tabBtn ${activeTab === "study" ? "vv-tabBtnActive" : ""}`}
              onClick={() => setActiveTab("study")}
              aria-selected={activeTab === "study"}
            >
              Guía de estudio
            </button>
          </nav>

          {activeTab === "video" ? (
            youtubeSrc ? (
              <div className="vv-videoShell">
                <div className="vv-videoInner">
                  <iframe
                    key={selected?.id}
                    src={youtubeSrc}
                    className="vv-iframe"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    title={selected?.title || "Clase"}
                  />

                  {!isPlaying && (
                    <button
                      type="button"
                      className="vv-videoOverlayBtn"
                      onClick={handlePlayClick}
                      aria-label="Reproducir video"
                    >
                      {overlayImage && (
                        <img
                          src={overlayImage}
                          alt={selected?.title || "Clase"}
                          className="vv-videoOverlayImg"
                        />
                      )}
                      <div className="vv-videoOverlayGradient" />
                      <div className="vv-videoOverlayContent">
                        <div className="vv-overlayPlayIcon">▶</div>
                        <div className="vv-overlayPlayText">Reproducir video</div>
                        <div className="vv-overlaySubtitle">
                          Haz clic para ver la clase sin distracciones.
                        </div>
                      </div>
                    </button>
                  )}

                  {isPlaying && <div className="vv-clickShield" />}
                </div>
              </div>
            ) : (
              <div
                style={{
                  padding: 24,
                  textAlign: "center",
                  border: "1px dashed #cbd5e1",
                  borderRadius: 8,
                }}
              >
                <p style={{ margin: 0, color: "#475569" }}>
                  Agrega el <strong>youtubeId</strong> real para esta clase en{" "}
                  <code>classesData</code> (arriba).
                </p>
              </div>
            )
          ) : (
            <section className="vv-materials">
              <h2 className="vv-materialsTitle">Guía / material de estudio</h2>
              {selected?.materials && selected.materials.length > 0 ? (
                <ul className="vv-materialsList">
                  {selected.materials.map((m, idx) => (
                    <li key={idx}>
                      <button
                        className="vv-materialItemBtn"
                        type="button"
                        onClick={() => handleMaterialClick(m.to)}
                      >
                        <span className="vv-materialBullet" />
                        <span>{m.label}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              ) : (
                <p style={{ margin: 0, fontSize: 13, color: "#6b7280" }}>
                  Aún no hay material de estudio para esta clase.
                </p>
              )}
            </section>
          )}
        </div>
      </main>
    </div>
  );
}
